import { combineReducers } from 'redux';
import ping from './ping/reducers';
import user from './user/reducers';
import timeline from './timeline/reducers';
import geoFeature from './geoFeature/reducers';
import layer from './layer/reducers';
import ontology from './ontology/reducers';
import modals from './modals/reducers';
import query from './query/reducers';
import network from './network/reducers';
import agentRegistry from './agentRegistry/reducers';

const data = combineReducers({
  ping,
  user,
  timeline,
  geoFeature,
  layer,
  ontology,
  modals,
  query,
  network,
  agentRegistry
});

export default data;
